import { createAsyncThunk } from "@reduxjs/toolkit";
import { Server } from "../../../../server";

export const setUserNameAction = (state: any, action: any) => {
  state.user_name = action.payload;
};

export const pinToDashboardAction = (state: any, action: any) => {
  state.pinToDashboardList = action.payload;
  localStorage.setItem("pinToDashboardList", JSON.stringify(action.payload));
};

export const setPagesAction = (state: any, action: any) => {
  state.pages = action.payload;
};

export const setSharedPageAction = (state: any, action: any) => {
  state.sharedPages = action.payload;
  localStorage.setItem("sharedPages", JSON.stringify(action.payload));
};
export const setdashboardDriveData = (state: any, action: any) => {
  state.DashboardDrive = action.payload;
 
};

// ---------- API CALL ----------
// Generates pending, fulfilled and rejected action types
export const UsersFetchAction = createAsyncThunk("dashboard/Users", () => {
  // TODO: --- USING AXIOS ---
  // return axios
  // 	.get('https://jsonplaceholder.typicode.com/users')
  // 	.then(response => response.data)

  // TODO: --- USING FETCH API ---
  // return fetch("https://jsonplaceholder.typicode.com/users", {
  // 	method: "GET",
  // 	headers: {
  // 		"Content-type": "application/json",
  // 	}
  // }).then(response => response.json())
  // 	.then(response => {
  // 		return response;
  // 	})

  // TODO: ----------- USING CUSTOM -----------
  Server.get("/users").then((response) => response);
});
